import axios from 'axios';
import { useStorage } from '../hooks/use-storage';

function useAccountMobileAPI() {
  const { userRef, menuIdRef, languageRef } = useStorage();

  function loadAccountMobileFromRemote() {
    const url = `/vbeta2/account/profile/mobile`;

    return axios({
      url,
      method: 'get',
      headers: {
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
        Authorization: `Bearer ${userRef?.current?.token}`,
      },
      responseType: 'json',
    });
  }

  function updateAccountMobileFromRemote(data) {
    const url = `/vbeta2/account/profile/mobile`;

    return axios({
      url,
      data,
      method: 'put',
      headers: {
        'Content-Type': 'text/plain',
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
        Authorization: `Bearer ${userRef?.current?.token}`,
      },
      responseType: 'json',
    });
  }

  return {
    loadAccountMobileFromRemote,
    updateAccountMobileFromRemote,
  };
}

export { useAccountMobileAPI };
